import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';
import { getUserDetailsState } from '../redux/userDetails/userSlice';

const BaseRouteHandler = () => {
  const userDetails = useSelector(getUserDetailsState);

  if (userDetails) return <Navigate to={'/admin'} replace />;
  return <Outlet />;
};

export default BaseRouteHandler;
